function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.92a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,43.92,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.92,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.63,
    y: 328.62,
    width: 70.34,
    height: 24.28,
    transform: "translate(645.59 681.52) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.63,
    y: 352.9,
    width: 70.34,
    height: 24.28,
    transform: "translate(645.59 730.08) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.24 352.9 322.49 328.62 335.95 328.62 344.71 352.9 331.24 352.9",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.97 328.62 318.93 328.62 327.68 352.9 324.72 352.9 315.97 328.62",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.99 377.18 331.24 352.9 344.71 352.9 353.46 377.18 339.99 377.18",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.72 352.9 327.68 352.9 336.43 377.18 333.47 377.18 324.72 352.9",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.57,
    y: 295.95,
    width: 2.46,
    height: 70.34,
    transform: "translate(653.92 8.33) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.57,
    y: 320.04,
    width: 2.46,
    height: 70.34,
    transform: "translate(678.01 32.42) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,343.87a1.06,1.06,0,1,1,0-2.11h3.6a1.06,1.06,0,0,1,0,2.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,343.49a1.06,1.06,0,1,1,0-2.11h3.6a1.06,1.06,0,0,1,0,2.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,366.28a1.06,1.06,0,1,1,0-2.11h3.6a1.06,1.06,0,0,1,0,2.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,365.91a1.06,1.06,0,1,1,0-2.11h3.6a1.06,1.06,0,0,1,0,2.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.4,327.53v50.71h72.8V327.53Zm2.45,26.65h67.89v21.6H288.85Zm0-24.06h67.89v21.61H288.85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.83,
    y: 328.62,
    width: 70.34,
    height: 24.28,
    transform: "translate(500 681.52) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.83,
    y: 352.9,
    width: 70.34,
    height: 24.28,
    transform: "translate(500 730.08) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.63 352.9 221.88 328.62 235.35 328.62 244.1 352.9 230.63 352.9",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.36 328.62 218.32 328.62 227.07 352.9 224.11 352.9 215.36 328.62",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.38 377.18 230.63 352.9 244.1 352.9 252.85 377.18 239.38 377.18",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.11 352.9 227.07 352.9 235.82 377.18 232.87 377.18 224.11 352.9",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.77,
    y: 295.95,
    width: 2.46,
    height: 70.34,
    transform: "translate(581.12 81.12) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.77,
    y: 320.04,
    width: 2.46,
    height: 70.34,
    transform: "translate(605.21 105.21) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.2,343.87a1.06,1.06,0,0,1,0-2.11h3.6a1.06,1.06,0,0,1,0,2.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.2,343.49a1.06,1.06,0,0,1,0-2.11h3.6a1.06,1.06,0,0,1,0,2.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.2,366.28a1.06,1.06,0,0,1,0-2.11h3.6a1.06,1.06,0,0,1,0,2.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.2,365.91a1.06,1.06,0,0,1,0-2.11h3.6a1.06,1.06,0,0,1,0,2.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.6,327.53v50.71h72.8V327.53Zm2.46,26.65h67.88v21.6H216.06Zm0-24.06h67.88v21.61H216.06Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.03,
    y: 328.62,
    width: 70.34,
    height: 24.28,
    transform: "translate(354.41 681.52) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.03,
    y: 352.9,
    width: 70.34,
    height: 24.28,
    transform: "translate(354.41 730.08) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.83 352.9 159.08 328.62 172.55 328.62 181.3 352.9 167.83 352.9",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.56 328.62 155.52 328.62 164.27 352.9 161.31 352.9 152.56 328.62",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.58 377.18 167.83 352.9 181.3 352.9 190.05 377.18 176.58 377.18",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.31 352.9 164.27 352.9 173.02 377.18 170.06 377.18 161.31 352.9",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.98,
    y: 295.95,
    width: 2.46,
    height: 70.34,
    transform: "translate(508.33 153.92) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.98,
    y: 320.04,
    width: 2.46,
    height: 70.34,
    transform: "translate(532.42 178.01) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.4,343.87a1.06,1.06,0,0,1,0-2.11H179a1.06,1.06,0,1,1,0,2.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.4,343.49a1.06,1.06,0,0,1,0-2.11H179a1.06,1.06,0,1,1,0,2.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.4,366.28a1.06,1.06,0,0,1,0-2.11H179a1.06,1.06,0,1,1,0,2.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.4,365.91a1.06,1.06,0,0,1,0-2.11H179a1.06,1.06,0,1,1,0,2.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.8,327.53v50.71h72.8V327.53Zm2.46,26.65h67.89v21.6H143.26Zm0-24.06h67.89v21.61H143.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.84 381.89 352.16 381.89 353.22 378.24 146.78 378.24 147.84 381.89",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8,274.24a3.44,3.44,0,1,1,.72-5.22c-.79-8.85-8.2-10.16-15.35-9.29a2.51,2.51,0,0,1,.66.64,2.72,2.72,0,1,1-4.41,0,59.31,59.31,0,0,0-10,3.14c.68,2.27,1.38,4.31,2.1,6.16a3,3,0,0,1,3.24,5.1,3.56,3.56,0,0,1-.78.39,27.24,27.24,0,0,0,4.92,7,3,3,0,1,1,4.79,2.27,2.76,2.76,0,0,1-.93.45c7.56,3.38,14.06-4.37,14.06-4.37a41.67,41.67,0,0,0,1.51-6.73A4.35,4.35,0,0,1,80.8,274.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.61,297.54c-8.92-13.88-23.19-25.13-37.66-32.6-.76-.4-1.3.82-.54,1.21,14.27,7.37,28.33,18.5,37.12,32.17.46.72,1.54-.06,1.08-.78Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.27,254.69a5.82,5.82,0,1,1,6.17-6.44c7.71-12.9-1.15-22.06-11.8-28a4.76,4.76,0,0,1,.27,1.52,4.62,4.62,0,1,1-6-4.36,100.14,100.14,0,0,0-16.77-5.59c-1.32,3.78-2.39,7.28-3.25,10.53a5.11,5.11,0,1,1-2.08,10,46.66,46.66,0,0,0-.21,14.48,5.12,5.12,0,1,1,4.31,7.88,4.91,4.91,0,0,1-1.72-.32c7,12.14,23.61,8,23.61,8a70.56,70.56,0,0,0,8.75-7.72A5.58,5.58,0,0,1,101.27,254.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,300.33c1.56-27.87-6.81-57.46-19.21-82.08-.65-1.29-2.6-.15-2,1.14,12.23,24.26,20.45,53.47,18.91,80.94-.08,1.45,2.17,1.44,2.25,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.86,325c0-8.51,13.35-5,16.71-18.18,1.28-5-9.58-16.33-9.58-16.33h33.85s-10.86,11.32-9.58,16.33C106.62,320,120,316.46,120,325c0,9.38-18.83,28.91-19.74,50.89-.08,2,3.54,6,3.54,6H88.05s3.63-4.07,3.55-6C90.69,353.88,71.86,334.35,71.86,325Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.09,347.1c-2-4.14,2.1-18.21,2.1-18.21H69.52s4.07,14.07,2.1,18.21c-1.39,2.92-4.54,4.78-4.54,8.24v20.77c0,5.38,4.4,5.78,9.78,5.78s9.78-.4,9.78-5.78V355.34C86.64,351.88,83.48,350,82.09,347.1Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.21,181.21V161.73h-1.5v19.48a2.41,2.41,0,0,0-1.67,2.28v6.17a2.42,2.42,0,0,0,2.42,2.42h0a2.42,2.42,0,0,0,2.42-2.42v-6.17A2.39,2.39,0,0,0,415.21,181.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.54,
    y: 161.73,
    width: 2.99,
    height: 219.26,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.53,381.89h-39a3.66,3.66,0,0,1,3.65-3.65h31.7a3.65,3.65,0,0,1,3.65,3.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.54 177.24 422.53 176.26 422.53 161.73 419.54 161.73 419.54 177.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.93 116.24 403.13 116.24 392.13 163.74 449.93 163.74 438.93 116.24",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-32"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-32",
    cx: 245.18,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.22,
    y: 111.49,
    width: 290.67,
    height: 202.67,
    rx: 4.63,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.22,
    y: 111.49,
    width: 290.67,
    height: 202.67,
    rx: 4.63,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.89,
    y: 206.49,
    width: 166.67,
    height: 101.33,
    rx: 4.05,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.89,
    y: 206.49,
    width: 166.67,
    height: 101.33,
    rx: 4.05,
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.54,
    y: 152.49,
    width: 260.02,
    height: 47.67,
    rx: 6.5,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.54,
    y: 152.49,
    width: 260.02,
    height: 47.67,
    rx: 6.5,
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.26,111.49H80.85a4.63,4.63,0,0,0-4.63,4.63v30H366.89v-30A4.63,4.63,0,0,0,362.26,111.49Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.26,111.49H80.85a4.63,4.63,0,0,0-4.63,4.63v30H366.89v-30A4.63,4.63,0,0,0,362.26,111.49Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.26,111.49H80.85a4.63,4.63,0,0,0-4.63,4.63v9.2H366.89v-9.2A4.63,4.63,0,0,0,362.26,111.49Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52,118.41a3,3,0,1,1-3-3A3,3,0,0,1,88.52,118.41Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.52,118.41a3,3,0,1,1-3-3A3,3,0,0,1,97.52,118.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.52,118.41a3,3,0,1,1-3-3A3,3,0,0,1,106.52,118.41Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.56,129.63H217.32a5.22,5.22,0,1,0,0,10.44H334.56a5.22,5.22,0,0,0,0-10.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.36,231.72H192.51a1.7,1.7,0,1,0,0,3.4h32.85a1.7,1.7,0,0,0,0-3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.61,231.72H232.76a1.7,1.7,0,1,0,0,3.4h49.85a1.7,1.7,0,0,0,0-3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.86,231.72H290a1.7,1.7,0,1,0,0,3.4h48.85a1.7,1.7,0,0,0,0-3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.36,241.87H192.51a1.7,1.7,0,1,0,0,3.4h35.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.61,241.87H235.76a1.7,1.7,0,1,0,0,3.4h37.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.86,241.87H281a1.7,1.7,0,1,0,0,3.4h46.85a1.7,1.7,0,0,0,0-3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.36,252H192.51a1.71,1.71,0,0,0,0,3.41h43.85a1.71,1.71,0,0,0,0-3.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,252H243.76a1.71,1.71,0,0,0,0,3.41h43.85a1.71,1.71,0,0,0,0-3.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.86,252H295a1.71,1.71,0,0,0,0,3.41h33.85a1.71,1.71,0,0,0,0-3.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.36,262.17H192.51a1.71,1.71,0,0,0,0,3.41h43.85a1.71,1.71,0,0,0,0-3.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.61,262.17H243.76a1.71,1.71,0,0,0,0,3.41h24.85a1.71,1.71,0,0,0,0-3.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.86,262.17H276a1.71,1.71,0,0,0,0,3.41h45.85a1.71,1.71,0,0,0,0-3.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.36,272.33H192.51a1.7,1.7,0,0,0,0,3.4h59.85a1.7,1.7,0,0,0,0-3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,272.33H259.76a1.7,1.7,0,1,0,0,3.4h27.85a1.7,1.7,0,0,0,0-3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,272.33H295a1.7,1.7,0,1,0,0,3.4h20.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.36,282.48H192.51a1.7,1.7,0,1,0,0,3.4h43.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,282.48H243.76a1.7,1.7,0,1,0,0,3.4h43.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.86,282.48H295a1.7,1.7,0,1,0,0,3.4h32.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.36,292.63H192.51a1.7,1.7,0,1,0,0,3.4h34.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,292.63H234.76a1.7,1.7,0,1,0,0,3.4h52.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.86,292.63H295a1.7,1.7,0,1,0,0,3.4h18.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.36,231.72H192.51a1.7,1.7,0,1,0,0,3.4h32.85a1.7,1.7,0,0,0,0-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.61,231.72H232.76a1.7,1.7,0,1,0,0,3.4h49.85a1.7,1.7,0,0,0,0-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.86,231.72H290a1.7,1.7,0,1,0,0,3.4h48.85a1.7,1.7,0,0,0,0-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.36,241.87H192.51a1.7,1.7,0,1,0,0,3.4h35.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.61,241.87H235.76a1.7,1.7,0,1,0,0,3.4h37.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.86,241.87H281a1.7,1.7,0,1,0,0,3.4h46.85a1.7,1.7,0,0,0,0-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.36,252H192.51a1.71,1.71,0,0,0,0,3.41h43.85a1.71,1.71,0,0,0,0-3.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,252H243.76a1.71,1.71,0,0,0,0,3.41h43.85a1.71,1.71,0,0,0,0-3.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.86,252H295a1.71,1.71,0,0,0,0,3.41h33.85a1.71,1.71,0,0,0,0-3.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.36,262.17H192.51a1.71,1.71,0,0,0,0,3.41h43.85a1.71,1.71,0,0,0,0-3.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.61,262.17H243.76a1.71,1.71,0,0,0,0,3.41h24.85a1.71,1.71,0,0,0,0-3.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.86,262.17H276a1.71,1.71,0,0,0,0,3.41h45.85a1.71,1.71,0,0,0,0-3.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.36,272.33H192.51a1.7,1.7,0,0,0,0,3.4h59.85a1.7,1.7,0,0,0,0-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,272.33H259.76a1.7,1.7,0,1,0,0,3.4h27.85a1.7,1.7,0,0,0,0-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,272.33H295a1.7,1.7,0,1,0,0,3.4h20.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.36,282.48H192.51a1.7,1.7,0,1,0,0,3.4h43.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,282.48H243.76a1.7,1.7,0,1,0,0,3.4h43.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.86,282.48H295a1.7,1.7,0,1,0,0,3.4h32.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.36,292.63H192.51a1.7,1.7,0,1,0,0,3.4h34.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,292.63H234.76a1.7,1.7,0,1,0,0,3.4h52.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.86,292.63H295a1.7,1.7,0,1,0,0,3.4h18.85a1.7,1.7,0,1,0,0-3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.06,269.72H97.61a2.39,2.39,0,1,0,0,4.77h61.45a2.39,2.39,0,0,0,0-4.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.56,279.72H97.61a2.39,2.39,0,1,0,0,4.77h53a2.39,2.39,0,0,0,0-4.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.81,289.72H97.61a2.39,2.39,0,1,0,0,4.77h58.2a2.39,2.39,0,0,0,0-4.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.31,299.72H97.61a2.39,2.39,0,1,0,0,4.77h49.7a2.39,2.39,0,0,0,0-4.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.06,269.72H97.61a2.39,2.39,0,1,0,0,4.77h61.45a2.39,2.39,0,0,0,0-4.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.56,279.72H97.61a2.39,2.39,0,1,0,0,4.77h53a2.39,2.39,0,0,0,0-4.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.81,289.72H97.61a2.39,2.39,0,1,0,0,4.77h58.2a2.39,2.39,0,0,0,0-4.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.31,299.72H97.61a2.39,2.39,0,1,0,0,4.77h49.7a2.39,2.39,0,0,0,0-4.77Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.91,132.43h7.3a1.19,1.19,0,0,0,0-2.37h-7.3a1.19,1.19,0,1,0,0,2.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.21,133.66h-7.3a1.19,1.19,0,1,0,0,2.37h7.3a1.19,1.19,0,0,0,0-2.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.21,137.26h-7.3a1.19,1.19,0,1,0,0,2.37h7.3a1.19,1.19,0,0,0,0-2.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.56,
    y: 128.87,
    width: 11.96,
    height: 11.96,
    rx: 3.06,
    style: {
      fill: "#263238",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.81,
    y: 210.16,
    width: 36.83,
    height: 12.33,
    rx: 3.23,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.14,
    y: 210.16,
    width: 36.83,
    height: 12.33,
    rx: 3.23,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.14,
    y: 210.16,
    width: 36.83,
    height: 12.33,
    rx: 3.23,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.48,
    y: 210.16,
    width: 36.83,
    height: 12.33,
    rx: 3.23,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.48,
    y: 210.16,
    width: 36.83,
    height: 12.33,
    rx: 3.23,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.82,
    y: 210.16,
    width: 36.83,
    height: 12.33,
    rx: 3.23,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.82,
    y: 210.16,
    width: 36.83,
    height: 12.33,
    rx: 3.23,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.22,
    y: 249.49,
    width: 75.67,
    height: 15,
    rx: 2.55,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.02 180.28 161.14 200.16 200.89 200.16 181.02 180.28",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.02 180.28 161.14 200.16 200.89 200.16 181.02 180.28",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.06 160.82 187.72 200.16 266.39 200.16 227.06 160.82",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.06 160.82 187.72 200.16 266.39 200.16 227.06 160.82",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.97 184.3 251.11 200.16 282.82 200.16 266.97 184.3",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.31 184.3 277.45 200.16 309.16 200.16 293.31 184.3",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.31 184.3 277.45 200.16 309.16 200.16 293.31 184.3",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,200.16h54a6.46,6.46,0,0,0,3-.74l-28.14-28.15Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,200.16h54a6.46,6.46,0,0,0,3-.74l-28.14-28.15Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.22,
    y: 160.82,
    width: 75.67,
    height: 75.67,
    rx: 8.72,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.22,
    y: 160.82,
    width: 75.67,
    height: 75.67,
    rx: 8.72,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.69,176s27.81,3.14,25-4.71c-2.13-6-8-1.06-8-1.06s-1-4.8-5.59-4.33-4.34,6.15-4.34,6.15S262.52,170.26,262.69,176Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.69,176s27.81,3.14,25-4.71c-2.13-6-8-1.06-8-1.06s-1-4.8-5.59-4.33-4.34,6.15-4.34,6.15S262.52,170.26,262.69,176Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.7,167.28s20.61,2.33,18.56-3.49c-1.58-4.47-5.94-.78-5.94-.78s-.76-3.56-4.15-3.21-3.21,4.55-3.21,4.55S289.57,163,289.7,167.28Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.7,167.28s20.61,2.33,18.56-3.49c-1.58-4.47-5.94-.78-5.94-.78s-.76-3.56-4.15-3.21-3.21,4.55-3.21,4.55S289.57,163,289.7,167.28Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.67,169.65s29.63,2.17,32-4.87c2.23-6.7-6.76-7.35-7.58-1.95,0,0-.41-6.48-5.95-6.36s-6.14,6.36-6.14,6.36-.6-2.58-3.9-2.29c-3.57.31-3.89,5.06-3.89,5.06S185.47,165.34,185.67,169.65Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.67,169.65s29.63,2.17,32-4.87c2.23-6.7-6.76-7.35-7.58-1.95,0,0-.41-6.48-5.95-6.36s-6.14,6.36-6.14,6.36-.6-2.58-3.9-2.29c-3.57.31-3.89,5.06-3.89,5.06S185.47,165.34,185.67,169.65Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.38,156.61s3.42-3.22,4.78,1.07A5.51,5.51,0,0,0,133.38,156.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.78,258.85h-3l-.57,1.39h-1.55l2.9-6.5H111l2.9,6.5h-1.58Zm-.48-1.15-1-2.48-1,2.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.25,257.45a1.61,1.61,0,0,1,.32,1,1.5,1.5,0,0,1-.67,1.31,3.41,3.41,0,0,1-1.93.46h-3.36v-6.5h3.17a3.07,3.07,0,0,1,1.83.46,1.43,1.43,0,0,1,.63,1.23,1.55,1.55,0,0,1-.22.84,1.65,1.65,0,0,1-.64.59A1.7,1.7,0,0,1,120.25,257.45Zm-4.15-2.58v1.53h1.5a1.49,1.49,0,0,0,.84-.19.72.72,0,0,0,0-1.15,1.58,1.58,0,0,0-.84-.19Zm2.65,4a.67.67,0,0,0,.31-.6q0-.81-1.2-.81H116.1v1.61h1.76A1.65,1.65,0,0,0,118.75,258.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,259.91a3.26,3.26,0,0,1-1.27-1.2,3.33,3.33,0,0,1,1.27-4.65,4.09,4.09,0,0,1,3.65,0,3.36,3.36,0,0,1,1.27,1.21,3.31,3.31,0,0,1-1.27,4.64,4,4,0,0,1-3.65,0Zm2.87-1.11a1.9,1.9,0,0,0,.73-.73,2.37,2.37,0,0,0,0-2.16,2,2,0,0,0-.73-.74,2.14,2.14,0,0,0-1-.26,2.11,2.11,0,0,0-1,.26,2,2,0,0,0-.73.74,2.3,2.3,0,0,0,0,2.16,1.9,1.9,0,0,0,.73.73,2,2,0,0,0,1,.27A2,2,0,0,0,125.9,258.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.26,259.58a3,3,0,0,1-.77-2.2v-3.64H131v3.58c0,1.17.49,1.75,1.45,1.75a1.37,1.37,0,0,0,1.08-.42,2,2,0,0,0,.37-1.33v-3.58h1.49v3.64a3.08,3.08,0,0,1-5.12,2.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.09,255H136v-1.23h5.66V255H139.6v5.27h-1.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,260.24v-3.9l-1.92,3.21h-.67l-1.91-3.13v3.82h-1.41v-6.5h1.25l2.43,4,2.39-4h1.24l0,6.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,259v1.21h-5v-6.5h4.91V255h-3.42v1.41h3v1.17h-3V259Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "392.84 411.8 396.44 411.8 391.18 340.2 385.57 340.2 392.84 411.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 411.8 356.4 411.8 359.66 340.2 365.26 340.2 360 411.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.87 411.8 381.47 411.8 378.2 340.2 372.6 340.2 377.87 411.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.03 411.8 341.43 411.8 346.69 340.2 352.29 340.2 345.03 411.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.84 411.8 396.44 411.8 391.18 340.2 385.57 340.2 392.84 411.8",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 411.8 356.4 411.8 359.66 340.2 365.26 340.2 360 411.8",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.87 411.8 381.47 411.8 378.2 340.2 372.6 340.2 377.87 411.8",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.03 411.8 341.43 411.8 346.69 340.2 352.29 340.2 345.03 411.8",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.69 340.2 352.29 340.2 351.63 346.68 346.21 346.68 346.69 340.2",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.66 340.2 365.26 340.2 364.79 346.68 359.37 346.68 359.66 340.2",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.5 346.68 373.08 346.68 372.6 340.2 378.2 340.2 378.5 346.68",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.65 346.68 386.23 346.68 385.57 340.2 391.18 340.2 391.65 346.68",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.13,330.39H394a0,0,0,0,1,0,0v3.22a5.95,5.95,0,0,1-5.95,5.95h-39a5.95,5.95,0,0,1-5.95-5.95v-3.22A0,0,0,0,1,343.13,330.39Z",
    transform: "translate(737.16 669.95) rotate(180)",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.13,330.39H394a0,0,0,0,1,0,0v3.22a5.95,5.95,0,0,1-5.95,5.95h-39a5.95,5.95,0,0,1-5.95-5.95v-3.22A0,0,0,0,1,343.13,330.39Z",
    transform: "translate(737.16 669.95) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.13,
    y: 337.39,
    width: 54.91,
    height: 5.16,
    rx: 0.93,
    transform: "translate(737.16 679.95) rotate(180)",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.51,209.54s10.92-1,12.92,10.88c1.63,9.72,9,14.18,3.38,20.5-5,5.56-11.38,1.16-21.82,2.25s-5.69-7.25-7.27-15.63C347.45,220.81,347.39,208,361.51,209.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.93,231.55l-7.42,7.29c1.25,6-3.15,6.56-3.15,6.56s.35,2.1,5.73,1.82a33.38,33.38,0,0,0,7.14-.86C368,243.77,368.46,235.89,368.93,231.55Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.58,242.22a7.93,7.93,0,0,0-.07-3.38l6.62-6.5.65.75S367.45,241.38,361.58,242.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.55,221.9c.54,7.15.93,10.16-2.15,14.29-4.62,6.21-13.52,5.32-16.19-1.52-2.4-6.16-2.89-16.8,3.65-20.58a9.78,9.78,0,0,1,13.38,3.5A9.94,9.94,0,0,1,369.55,221.9Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.29,233.77c.08.58-.16,1.09-.54,1.15s-.74-.38-.83-.95.16-1.09.54-1.15S356.21,233.2,356.29,233.77Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.43,227a15.72,15.72,0,0,1-1.54,4,2.46,2.46,0,0,0,2.1.11Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.84,222.14a.27.27,0,0,0,.12-.09.28.28,0,0,0,0-.4h0a3.31,3.31,0,0,0-3-.74.29.29,0,0,0,.16.55,2.79,2.79,0,0,1,2.46.63A.29.29,0,0,0,359.84,222.14Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.28,223.12a.5.5,0,0,0,.12-.08,2.76,2.76,0,0,1,2.33-1,.27.27,0,0,0,.32-.23h0a.29.29,0,0,0-.24-.32,3.34,3.34,0,0,0-2.84,1.16.28.28,0,0,0,.31.46Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.37,225.5c.09.57-.16,1.08-.54,1.13s-.74-.37-.82-.95.16-1.08.54-1.13S358.29,224.91,358.37,225.5Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.85,226.4c.08.57-.16,1.08-.53,1.13s-.75-.37-.83-.95.16-1.08.53-1.13S351.78,225.81,351.85,226.4Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.19,225.46l-1.44-.21S350.62,226.23,351.19,225.46Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.72,224.55l-1.44-.2S357.14,225.33,357.72,224.55Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.25,227s-5.38.56-6.44-4.86-2.5-6.16-2.5-6.16a4.84,4.84,0,0,1,.4,3.6c-.56,2.06-5.31-.94-8.81.75s1.27-6.67,1.27-6.67l1.82-2.18h6.26l6.12,1.26s2.48,2.61,2.55,2.86,1.61,2.38,1.31,2.75,0,5.19,0,5.19l-.84,3.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,227.27a5.25,5.25,0,0,1-2.07,3.42c-1.5,1.07-2.87-.11-3-1.85-.11-1.55.55-4,2.3-4.38a2.36,2.36,0,0,1,2.76,1.88A2.24,2.24,0,0,1,372,227.27Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.16,291.46h-9.49a52.64,52.64,0,0,0-3,13.21c-.5,6.75,12.49,1.75,12.49,1.75l1.14-9.25Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.16,291.46h-9.49a52.64,52.64,0,0,0-3,13.21c-.5,6.75,12.49,1.75,12.49,1.75l1.14-9.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.67 366.05 295.42 384.3 290.17 382.8 294.42 363.55 301.67 366.05",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.49,381.54c-.85-.22-1.69-.61-1.87-1a.62.62,0,0,1,.2-.7.86.86,0,0,1,.6-.25c1.23,0,3.25,2,3.34,2.06a.15.15,0,0,1,0,.18.16.16,0,0,1-.17.1A11.94,11.94,0,0,1,287.49,381.54Zm-.74-1.61a1.12,1.12,0,0,0-.32,0,.46.46,0,0,0-.37.14c-.18.17-.16.28-.13.35.2.52,1.92,1,3.23,1.16A7.55,7.55,0,0,0,286.75,379.93Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.61,381.88a.08.08,0,0,1-.07,0c-.72-.58-2-2.49-1.63-3.22.07-.18.26-.37.72-.29a1.23,1.23,0,0,1,.83.51,4.84,4.84,0,0,1,.37,2.92.16.16,0,0,1-.11.13A.14.14,0,0,1,289.61,381.88Zm-.95-3.2-.09,0c-.3,0-.35.06-.37.1-.16.45.61,1.89,1.33,2.61a3.92,3.92,0,0,0-.37-2.33.89.89,0,0,0-.5-.35Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.27,381.4l6.45,2a.62.62,0,0,1,.47.62l-.24,6.42a1,1,0,0,1-1.06,1l-.22,0c-2.67-.75-5-1.52-8.37-2.39-3.95-1-3.07-.3-7.73-1.45-2.81-.69-2.49-4-1.27-3.85,5.61.73,7.6-.76,10.2-2.15A2.46,2.46,0,0,1,290.27,381.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.27 376 292.03 374.4 294.42 363.55 301.67 366.05 298.27 376",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.09,290.59s9.67,16.17,8,29.67-14.15,20.64-62.15-2.36c0,0-9.85,10.19-26.18,53.86l-8.34-2.5s9.42-50.48,17.84-64.84,45.83,2.5,48.66-.33c2.53-2.52.34-12.5.34-12.5Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.8 370.93 301.05 374.3 291.05 370.93 291.05 367.05 302.8 370.93",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.8 370.93 301.05 374.3 291.05 370.93 291.05 367.05 302.8 370.93",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.93 388.42 344.01 404.58 338.13 404.73 333.89 389.15 341.93 388.42",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.1,404.92a3,3,0,0,1-2.07-.54.63.63,0,0,1,0-.73.87.87,0,0,1,.53-.39c1.18-.32,3.64,1.09,3.75,1.15a.18.18,0,0,1,.08.18.17.17,0,0,1-.14.13A12,12,0,0,1,335.1,404.92ZM334,403.54a1.17,1.17,0,0,0-.32,0,.48.48,0,0,0-.33.24c-.12.2-.08.3,0,.36.33.46,2.11.48,3.42.32A7.79,7.79,0,0,0,334,403.54Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.24,404.72h-.07c-.85-.38-2.54-1.92-2.39-2.71,0-.19.16-.42.63-.47a1.27,1.27,0,0,1,.93.29,4.86,4.86,0,0,1,1.09,2.73.21.21,0,0,1-.08.16Zm-1.72-2.86h-.1c-.3,0-.32.15-.33.19,0,.48,1.06,1.68,1.94,2.2a4,4,0,0,0-.94-2.17.86.86,0,0,0-.57-.21Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.06,403.83l6.7,0a.63.63,0,0,1,.61.49l1.37,6.27a1,1,0,0,1-.77,1.24l-.22,0c-2.78-.05-5.25-.21-8.71-.22-4.08,0-3,.49-7.84.54-2.89,0-3.41-3.26-2.19-3.41,5.62-.7,7.2-2.39,9.37-4.39A2.49,2.49,0,0,1,338.06,403.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.35 398.19 333.89 389.15 341.93 388.42 343.13 397.76 336.35 398.19",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.94,317.9h0c15.15,7.18,26.82,11.37,35.74,13.28H336.42c1.25,3,6.63,60.75,6.63,60.75l-9.13.8s-19.75-57.92-19-66.3S326.94,317.9,326.94,317.9Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.94,317.9h0c15.15,7.18,26.82,11.37,35.74,13.28H336.42c1.25,3,6.63,60.75,6.63,60.75l-9.13.8s-19.75-57.92-19-66.3S326.94,317.9,326.94,317.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.14 390.43 344.39 394.18 333.77 395.01 332.26 391.44 344.14 390.43",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.14 390.43 344.39 394.18 333.77 395.01 332.26 391.44 344.14 390.43",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.37,271l-8.83-1.72-2-5.74-4.38-4.22-1.42,3.46a1.83,1.83,0,0,0,.06,1.55l3.11,6.12,12.36,5.36Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.42,261c1.07-4.68,2.75-15.37-2.5-16.12-6.94-1-4.53,21-10.75,25.33-3.41,2.37-15.48-.89-15.48-.89l-1.22,4.93s15.58,7.15,20.58,5.5C348.84,277.83,351,267.28,352.42,261Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.42,261c1.07-4.68,2.75-15.37-2.5-16.12-6.94-1-4.53,21-10.75,25.33-3.41,2.37-15.48-.89-15.48-.89l-1.22,4.93s15.58,7.15,20.58,5.5C348.84,277.83,351,267.28,352.42,261Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.61,249.65c-2,7.63-8.57,26.12-4.19,41.94,0,0-19.55,2.65-30.55.87l-4.47-44a3.35,3.35,0,0,1,3.58-3.64l34,2.55A1.82,1.82,0,0,1,386.61,249.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.37,269.38,341.93,267l-2.43-7.75a1.38,1.38,0,0,0-.8-.88L335.12,257a1.38,1.38,0,0,0-1.83,1.62l1.29,5.72a1.36,1.36,0,0,0,.34.65l5,5.3,7.22,3.5Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.65,276.68h-3.44L325,252h3.45a2.68,2.68,0,0,1,2.49,2.06l4.37,20.55A1.61,1.61,0,0,1,333.65,276.68Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.41,252H314.9a1.61,1.61,0,0,0-1.62,2.06l4.37,20.55a2.67,2.67,0,0,0,2.49,2.06h12.51a1.61,1.61,0,0,0,1.62-2.06l-4.37-20.55A2.68,2.68,0,0,0,327.41,252Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.41,252H314.9a1.61,1.61,0,0,0-1.62,2.06l4.37,20.55a2.67,2.67,0,0,0,2.49,2.06h12.51a1.61,1.61,0,0,0,1.62-2.06l-4.37-20.55A2.68,2.68,0,0,0,327.41,252Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,253.6h-1.67a.22.22,0,0,0-.22.27l.59,2.75a.35.35,0,0,0,.33.27h1.67a.22.22,0,0,0,.22-.27l-.59-2.75A.35.35,0,0,0,328,253.6Z",
    style: {
      fill: "#263238",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.36,261.06l.95-2.36a1,1,0,0,1,1.7-.31h0a1,1,0,0,1,.26.55l.9,6.57a1,1,0,0,1-.22.77l-1.72,2.17-1.91-6.73A1.06,1.06,0,0,1,313.36,261.06Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.17,271.4c3.43-5.1,11.84-19.24,6.24-23.17-5-3.5-9.62,8.12-17,20.08-.56.91-1.14,1.83-1.73,2.74a2.9,2.9,0,0,1-3.08,1.26l-3-.69L344,267.31l-1.18,4.86s19.54,11.52,24.56,11.52S377.89,276.28,381.17,271.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.17,271.4c3.43-5.1,11.84-19.24,6.24-23.17-5-3.5-9.62,8.12-17,20.08-.56.91-1.14,1.83-1.73,2.74a2.9,2.9,0,0,1-3.08,1.26l-3-.69L344,267.31l-1.18,4.86s19.54,11.52,24.56,11.52S377.89,276.28,381.17,271.4Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.64,246.63l-.82-1.41a.71.71,0,0,1-.08-.18l-.33-1.08a.82.82,0,0,0-.82-.59,59.27,59.27,0,0,1-9.85-.43.66.66,0,0,0-.78.64,2.5,2.5,0,0,1,0,.93c-.21.36-1.46.82-1.46.82S357.43,248.76,371.64,246.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.81,250.54a1.27,1.27,0,0,1,1.85-1.15,1.27,1.27,0,0,1-.35-.88,1.28,1.28,0,0,1,1.29-1.29h.09a1.29,1.29,0,1,1,.92.4l-.09,0a1.27,1.27,0,0,1,.37.9,1.29,1.29,0,0,1-1.29,1.29,1.37,1.37,0,0,1-.57-.14,1.27,1.27,0,0,1,.36.88,1.29,1.29,0,1,1-2.58,0Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.89,252.38a1.3,1.3,0,1,1,1.29,1.29A1.3,1.3,0,0,1,365.89,252.38Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,252.38a1.29,1.29,0,1,1-1.29,1.29A1.28,1.28,0,0,1,365,252.38Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.52,253a1.29,1.29,0,1,1-1.3,1.29A1.29,1.29,0,0,1,362.52,253Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.93,252.87a1.3,1.3,0,1,1-1.29,1.29A1.29,1.29,0,0,1,359.93,252.87Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.51,252a1.29,1.29,0,1,1-1.29,1.29A1.29,1.29,0,0,1,357.51,252Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.08,249.8a1.29,1.29,0,1,1,1.31-1.29,1.3,1.3,0,0,1-1.31,1.29,1.29,1.29,0,0,1,0,2.58,1.29,1.29,0,0,1,0-2.58Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.77,247.33a1.29,1.29,0,1,1,1.29-1.29A1.29,1.29,0,0,1,356.77,247.33Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.81,250.54a1.27,1.27,0,0,1,1.85-1.15,1.27,1.27,0,0,1-.35-.88,1.28,1.28,0,0,1,1.29-1.29h.09a1.29,1.29,0,1,1,.92.4l-.09,0a1.27,1.27,0,0,1,.37.9,1.29,1.29,0,0,1-1.29,1.29,1.37,1.37,0,0,1-.57-.14,1.27,1.27,0,0,1,.36.88,1.29,1.29,0,1,1-2.58,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.89,252.38a1.3,1.3,0,1,1,1.29,1.29A1.3,1.3,0,0,1,365.89,252.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,252.38a1.29,1.29,0,1,1-1.29,1.29A1.28,1.28,0,0,1,365,252.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.52,253a1.29,1.29,0,1,1-1.3,1.29A1.29,1.29,0,0,1,362.52,253Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.93,252.87a1.3,1.3,0,1,1-1.29,1.29A1.29,1.29,0,0,1,359.93,252.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.51,252a1.29,1.29,0,1,1-1.29,1.29A1.29,1.29,0,0,1,357.51,252Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.08,249.8a1.29,1.29,0,1,1,1.31-1.29,1.3,1.3,0,0,1-1.31,1.29,1.29,1.29,0,0,1,0,2.58,1.29,1.29,0,0,1,0-2.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.77,247.33a1.29,1.29,0,1,1,1.29-1.29A1.29,1.29,0,0,1,356.77,247.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.58,246.87s-7.62,1.21-11-.34C358.61,246.53,361.22,251.64,369.58,246.87Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "152.92 225.95 158.63 228.59 166.05 228.24 168.97 232.66 167.83 233.76 161.63 233.76 158.06 232.59 156.69 231.31 150.28 229.86 152.92 225.95",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,191.14s-5.71-5-7.31,12.4S136.79,223,140.6,226c4.8,3.77,12.7,5.87,12.7,5.87l3.24-4.9s-9.45-6-10.91-9.79C144.54,214.34,150,195.21,144,191.14Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,191.14s-5.71-5-7.31,12.4S136.79,223,140.6,226c4.8,3.77,12.7,5.87,12.7,5.87l3.24-4.9s-9.45-6-10.91-9.79C144.54,214.34,150,195.21,144,191.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.77,236.49h35.3c-.11-5.67-.25-13.55-.31-21.16-.13-14.19,5.4-28-16.34-28.91-21.13-.91-25.81-2.45-21.44,16.84A106.83,106.83,0,0,1,111.77,236.49Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.05,189.11a10.45,10.45,0,0,0,3,2.07,16.78,16.78,0,0,0,8,.92l2.5-1.22.17-1.42-.06-.35-.13,0c-4.77-.81-5.67-4.77-5.3-8.39l-10.15-6.4C122.52,178.19,124.29,184.93,123.05,189.11Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.7,186l1.64,2.36,4.46,3.08,5.2.8,3.77-.56,1.27-1.62-1.11-3a38.7,38.7,0,0,0-5.51-.6C126.67,186.26,123.45,186.08,120.7,186Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,193c6.16,0,4.81-3.65,3.44-5.84-.65-.14-1.33-.25-2-.35,1.77,1.66,3.75,4.4-2,4.69A11.46,11.46,0,0,1,121.7,186c-1,0-2-.06-2.87-.07C120,188.06,123.77,193,133,193Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,193c6.16,0,4.81-3.65,3.44-5.84-.65-.14-1.33-.25-2-.35,1.77,1.66,3.75,4.4-2,4.69A11.46,11.46,0,0,1,121.7,186c-1,0-2-.06-2.87-.07C120,188.06,123.77,193,133,193Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.29,176.91l6,3.76a14.77,14.77,0,0,0,0,2.66,7.37,7.37,0,0,1-6-3.42C124.58,178.64,124.79,177.14,125.29,176.91Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,167.93c-4.61-2.75-7.14-8.44-6.76-9.7s7.64-3.49,8.63-3c5,2.49,1.84,9.34,1.84,9.34l1.72,2.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.39,167.7c1.75,6.26,2.46,10,6.36,12.55,5.87,3.86,13.06-.75,13.2-7.38.13-6-2.77-15.19-9.51-16.37a8.85,8.85,0,0,0-10.27,7.13A8.76,8.76,0,0,0,118.39,167.7Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,172.17c-4.32-3.18-6.17-8.77-5.61-9.95a6.58,6.58,0,0,1,8.72-3.25c5,2.4.92,10.3.92,10.3l1.5,2.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.57,174.28a6.23,6.23,0,0,0,4.33,1.85c2.16,0,2.67-2.07,1.59-3.81-1-1.57-3.27-3.46-5.21-2.63A2.76,2.76,0,0,0,116.57,174.28Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.69,167.4c.11.51.48.87.81.8s.52-.55.41-1.07-.47-.87-.81-.79S128.58,166.88,128.69,167.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.52,166.14c.11.51.47.87.81.8s.52-.55.4-1.06-.47-.88-.81-.81S134.4,165.62,134.52,166.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.4,166.8a18.27,18.27,0,0,0,3.42,3.87,3.09,3.09,0,0,1-2.37,1Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.17,165.41H126a.32.32,0,0,1-.15-.41,3.11,3.11,0,0,1,2.19-1.78.31.31,0,1,1,.09.61h0a2.48,2.48,0,0,0-1.72,1.43A.29.29,0,0,1,126.17,165.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.27,163.3a.33.33,0,0,1-.27-.12,2.45,2.45,0,0,0-2-1,.3.3,0,0,1-.33-.28.31.31,0,0,1,.28-.34,3.08,3.08,0,0,1,2.54,1.24.3.3,0,0,1,0,.43h0A.26.26,0,0,1,136.27,163.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.68,161.49s19.83-1.87,14.21-9.91c-4.25-6.06-6.5-5.52-7.64-4.05a5,5,0,0,1-4.29,2c-2.72-.17-6.1.17-5.74,3a3.68,3.68,0,0,1-1.4,3.28C112.41,157.78,109.84,161.09,119.68,161.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.35,174.51a4.88,4.88,0,0,0,.86-.19.18.18,0,0,0,.13-.21h0a.19.19,0,0,0-.23-.11,4.76,4.76,0,0,1-4.23-.66.17.17,0,0,0-.24,0,.17.17,0,0,0,0,.25A4.87,4.87,0,0,0,133.35,174.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.88,218.25s.86-1.64,8.2,5l7.35,6.64,4.64,1.64,4.57,1.92v1.65h-4.36l-1.71-1A48.26,48.26,0,0,1,112,226.85c0-2.71-.18-5.52-.49-8.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,210.54l1.43-15.12,1.63-3.18h1.81a72.57,72.57,0,0,1,.49,17.35c-.23,3.23,1.32,9.57,8.11,14.92l-8.12-3.43-4.08-5.61.56-2.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,236.4H144.24a2.62,2.62,0,0,1-2.62-2.62h32.13A2.63,2.63,0,0,1,171.13,236.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,236.4H144.24a2.62,2.62,0,0,1-2.62-2.62h32.13A2.63,2.63,0,0,1,171.13,236.4Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.34,236.4H125.45a2.62,2.62,0,0,1-2.62-2.62H155A2.62,2.62,0,0,1,152.34,236.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.34,236.4H125.45a2.62,2.62,0,0,1-2.62-2.62H155A2.62,2.62,0,0,1,152.34,236.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.34,235.6H155a.63.63,0,0,1-.59-.83l9-25.68a1.77,1.77,0,0,1,1.67-1.18h16.39a.62.62,0,0,1,.59.82l-9,25.69A1.78,1.78,0,0,1,171.34,235.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.34,235.6H155a.63.63,0,0,1-.59-.83l9-25.68a1.77,1.77,0,0,1,1.67-1.18h16.39a.62.62,0,0,1,.59.82l-9,25.69A1.78,1.78,0,0,1,171.34,235.6Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.14,235.6h-16.4a.62.62,0,0,1-.58-.83l9-25.68a1.75,1.75,0,0,1,1.66-1.18H182.2a.62.62,0,0,1,.59.82l-9,25.69A1.78,1.78,0,0,1,172.14,235.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.14,235.6h-16.4a.62.62,0,0,1-.58-.83l9-25.68a1.75,1.75,0,0,1,1.66-1.18H182.2a.62.62,0,0,1,.59.82l-9,25.69A1.78,1.78,0,0,1,172.14,235.6Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.3,221.75c-.21,1-.89,1.78-1.52,1.78s-1-.79-.76-1.78.89-1.78,1.52-1.78S170.51,220.77,170.3,221.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.83 225.95 131.54 228.59 138.96 228.24 141.88 232.66 140.74 233.76 134.54 233.76 130.97 232.59 129.6 231.31 123.19 229.86 125.83 225.95",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.58,188.2s-6.57-5.06-8.16,12.4,2.31,21.5,9.94,25.67c5.35,2.93,12.69,5.87,12.69,5.87l3.25-4.9s-15.46-9.31-16.92-13.05C113.3,211.39,119.65,192.27,113.58,188.2Z",
    style: {
      fill: "#2DAF8E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383,226.72l2.82-1.7c1.13-.69,4.16-2.51,4.54-2.79.77-.55,1.36-1.53,1-2.21-.83-1.72-4.5-2.68-6.26-3.15-.61-.16-1-.27-1.28-.37-8.09-2.6-13.32-7.93-13.6-13.89-.45-9.28,10.95-17.4,25.41-18.09s26.59,6.29,27,15.56c.22,4.53-2.34,8.92-7.2,12.34a34.85,34.85,0,0,1-18.22,5.75c-.21,0-.27.38-.27.43-.44,3.47-2.56,4.5-4.11,5.25l-.21.1a24.11,24.11,0,0,1-4.94,1.6Zm14.66-41.25c-.65,0-1.29,0-1.95.05-13.9.67-24.87,8.31-24.45,17,.26,5.54,5.23,10.52,12.95,13,.22.09.65.2,1.14.33,2.1.56,5.92,1.56,6.95,3.7.58,1.2-.24,2.65-1.36,3.45h0c-.19.13-.94.6-1.77,1.11a18.09,18.09,0,0,0,3.09-1.11l.2-.1c1.49-.72,3.19-1.54,3.56-4.48a1.33,1.33,0,0,1,1.21-1.3,33.81,33.81,0,0,0,17.7-5.57c4.57-3.22,7-7.29,6.77-11.47C421.26,191.82,410.65,185.47,397.62,185.47Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.29,197.52h-2a1.85,1.85,0,0,0-1.82,1.73L385,208.6a1.63,1.63,0,0,0,1.64,1.73h2a1.85,1.85,0,0,0,1.82-1.73l.49-9.35A1.63,1.63,0,0,0,389.29,197.52Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.29,197.52h-2a1.85,1.85,0,0,0-1.82,1.73L385,208.6a1.63,1.63,0,0,0,1.64,1.73h2a1.85,1.85,0,0,0,1.82-1.73l.49-9.35A1.63,1.63,0,0,0,389.29,197.52Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.09,197.52h-5.93l.52-2.41a18.46,18.46,0,0,0,.49-3.84,2.38,2.38,0,0,0-1-1.68,4.39,4.39,0,0,0-2.69-.46l-.54.5c-.06,1.05-.41,3.78-1.06,4.6l-2.82,3.56a3,3,0,0,0-.64,1.67l-.46,8.73a2,2,0,0,0,2,2.14h8.29a2.61,2.61,0,0,0,1.93-.88l.78-.87a2.64,2.64,0,0,0,.61-1.17l1.81-8.09Z",
    style: {
      fill: "#2DAF8E"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.96911e5f471278f3b75a59f7b63c8109.svg";
export { ForwardRef as ReactComponent };